// extracted by mini-css-extract-plugin
export default {"container":"_3sJK2","time":"_3k1yr","title":"_14db2","chevron":"_146HW"};